import { render, staticRenderFns } from "./ReorderNotification.vue?vue&type=template&id=0427f2ff&scoped=true&"
import script from "./ReorderNotification.vue?vue&type=script&lang=ts&"
export * from "./ReorderNotification.vue?vue&type=script&lang=ts&"
import style0 from "./ReorderNotification.vue?vue&type=style&index=0&id=0427f2ff&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0427f2ff",
  null
  
)

export default component.exports